import ThirdPartyDeleteModal from './ThirdPartyDeleteModal';

export default ThirdPartyDeleteModal;
